let ctx = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

// Call on a user gesture so the browser allows audio playback later.
export function primeChatSound() { getCtx(); }

export function isChatSoundMuted() {
  try { return localStorage.getItem("chatSoundMuted") === "1"; } catch { return false; }
}
export function setChatSoundMuted(muted) {
  try { localStorage.setItem("chatSoundMuted", muted ? "1" : "0"); } catch { /* ignore */ }
}

// Short two-tone chime, no audio asset required.
export function playChatChime() {
  if (isChatSoundMuted()) return;
  const c = getCtx();
  if (!c) return;
  const now = c.currentTime;
  [880, 1174.66].forEach((freq, i) => {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = "sine";
    o.frequency.value = freq;
    const t = now + i * 0.14;
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(0.15, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.001, t + 0.13);
    o.connect(g);
    g.connect(c.destination);
    o.start(t);
    o.stop(t + 0.14);
  });
}
